import { useQuoteOptionParams } from '@components/Feature/HealthQuote/hook';

export const usePersonalAccidentQuoteResultPageParams = useQuoteOptionParams;
